import { GA } from '@phoenix/core/frontend/shared/feature/google-analytics/ga';

const VIEW_PRODUCT_EVENT_NAME = 'view_item_list';
const SELECT_PRODUCT_EVENT_NAME = 'select_item';

export type ProductEventData = {
  item_name: string;
  item_id: string;
  item_category?: string;
  product_power?: string;
  item_list_name?: string;
  index: number;
  picture_url?: string;
};

const event = (name: string, product: ProductEventData) =>
  GA.sendRawEvent({
    event: `ec.${name}`,
    event_name: name,
    ecommerce: { items: [{ item_list_name: 'toolshed', ...product, item_brand: 'STIHL' }] },
  });
const ecommerceEvent = (name: string) => (product: ProductEventData) => event(name, product);

export const ecommerceEvents = {
  impression: ecommerceEvent(VIEW_PRODUCT_EVENT_NAME),
  selection: ecommerceEvent(SELECT_PRODUCT_EVENT_NAME),
};
